/* eslint-disable prettier/prettier */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import FormFields from "../../atoms/FormFields";
import { Cards } from "../../atoms/Card";
import { Icons } from "../../atoms/Icons";
import { ErrorMessages } from "../../atoms/ErrorMessages";
import "./bank-mandate-form.scss";
import {
  checkFormFieldAccess,
  checkFieldEnabled,
  setCursorPostion,
} from "../../helpers/helpers";
import {
  WORK_ITEM_TYPE,
  IDV_STATUS,
  countryOptions,
} from "../../constants/constants";
import { useSelector } from "react-redux";
import CustomCheckbox from "../../atoms/CustomCheckbox";

const BankMandateForm = (props) => {
  const { bankAccounts, address, givenNames, name } = props.bankdetails;
  const memberType = props?.memberType;
  const { bankDetailPrefilledData } = props;
  const confirmAPIHandler = props?.confirmAPIHandler;
  const editDisable = props?.edit;
  const editIconHandler = props?.editIconHandler;
  const formFieldAccess = checkFormFieldAccess(memberType);
  useEffect(() => {
    if (props?.getBankDetails) {
      confirmHandler();
    }
  }, [props?.getBankDetails]);

  const { data } = useSelector((state) => state.account);
  const [status, setStatus] = useState(false);
  // prettier-ignore
  const [edit, setEdit] = useState(
     formFieldAccess.includes("bankdetail-section") ? false : true
  );
  const [displayButton, setDisplayButton] = useState(false);
  const [editSortCode, setEditSortCode] = useState(true);
  const [editAccountNumber, setEditAccountNumber] = useState(true);
  const [editAccountName, setEditAccountName] = useState(true);
  const [editBuildingSocietyCode, setEditBuildingSocietyCode] = useState(true);

  const [editSwift, setEditSwift] = useState(true);

  //Error useState
  const [sortCodeError, setSortCodeError] = useState("");
  const [accountNumberError, setAccountNumberError] = useState("");
  const [accountNameError, setAccountNameError] = useState("");
  const [societyCodeError, setSocietyCodeError] = useState("");
  const [swiftError, setSwiftError] = useState("");
  // pending status useState
  const [sortCodePending, setSortCodePending] = useState(false);
  const [accountNumberPending, setAccountNumberPending] = useState(false);
  const [accountNamePending, setAccountNamePending] = useState(false);
  const [societyCodePending, setSocietyCodePending] = useState(false);
  const [swiftPending, setSwiftPending] = useState(false);
  const [showUploadDocButton, setShowUploadDocButton] = useState(false);

  //is confirm changes clicked
  const [isClicked, setIsClicked] = useState(false);
  const [isError, setIsError] = useState(false);
  // prettier-ignore
  const [swift, setSwift] = useState(bankAccounts && bankAccounts?.length > 0 && bankAccounts[0]?.swift
      ? bankAccounts[0]?.swift
      : "");

  let sortCode =
    bankAccounts && bankAccounts?.length > 0 && bankAccounts[0]?.sortCode
      ? bankAccounts &&
        bankAccounts?.length > 0 &&
        bankAccounts[0]?.sortCode?.match(new RegExp(".{1,2}", "g")).join("-")
      : "";
  const [sortCodeValue, setSortCodeValue] = useState(sortCode);

  // prettier-ignore
  const [accountNumber, setAccountNumberValue] = useState(
    bankAccounts && bankAccounts?.length > 0 && bankAccounts[0]?.accountNumber
      ? bankAccounts[0]?.accountNumber
      : ""
  );
  // prettier-ignore
  const [accountName, setAccountName] = useState(
    bankAccounts && bankAccounts?.length > 0 ? bankAccounts[0]?.accountName : ""
  );
  // prettier-ignore
  const [societyCode, setsocietyCode] = useState(
    bankAccounts && bankAccounts?.length > 0
      ? bankAccounts[0]?.buildingSocietyCode
      : ""
  );
  const [showPendingStatus, setShowPendingStatus] = useState(false);

  useEffect(() => {
    if (props.isBankAccount) {
      setSortCodeValue(bankDetailPrefilledData?.sortCodeValue || "");
      setAccountNumberValue(bankDetailPrefilledData?.accountNumber || "");
      setAccountName(bankDetailPrefilledData?.accountName || "");
      setsocietyCode(bankDetailPrefilledData?.societyCode || "");
    } else {
      setSwift(bankDetailPrefilledData?.swift || "");
      setAccountNumberValue(bankDetailPrefilledData?.accountNumber || "");
      setAccountName(bankDetailPrefilledData?.accountName || "");
    }
  }, [props.isBankAccount]);

  useEffect(() => {
    if (props.isBankAccount) {
      if (sortCodeValue !== "" && accountNumber !== "" && accountName !== "") {
        props.buttonEnable(true);
      } else {
        props.buttonEnable(false);
      }
    } else {
      if (
        props.checked &&
        swift !== "" &&
        accountNumber !== "" &&
        accountName !== ""
      ) {
        props.buttonEnable(true);
      } else {
        props.buttonEnable(false);
      }
    }
  }, [
    sortCodeValue,
    accountNumber,
    accountName,
    swift,
    props.checked,
    props.isBankAccount,
  ]);

  const handleSortCode = (e) => {
    setSortCodeError("");
    let formattedText = e.target.value.split("-").join("");
    if (formattedText.length > 0) {
      formattedText = formattedText.match(new RegExp(".{1,2}", "g")).join("-");
    }
    const regex = /^[0-9-]+$/;
    if (regex.test(formattedText) || formattedText === "")
      setSortCodeValue(formattedText);
  };
  const handleAccountNumber = (e) => {
    const value = e.target.value;
    const regex = /^[0-9]+$/;
    if (regex.test(value) || value === "") {
      setAccountNumberValue(value);
    }
    setAccountNumberError("");
  };
  const handleAccountName = (e) => {
    setCursorPostion(e);
    const value = e.target.value.trimStart().replace(/\s+/g, " ");
    const regex = /^[A-Za-z ]+$/;
    if (regex.test(value) || value === "") {
      setAccountName(value);
    }
    setAccountNameError("");
  };
  const handleSocietyCode = (e) => {
    setCursorPostion(e);
    const value = e.target.value.trimStart().replace(/\s+/g, " ");
    const regex = /^[A-Za-z0-9-' ]+$/;
    if (regex.test(value) || value === "") {
      setsocietyCode(value);
    }
    setSocietyCodeError("");
  };

  const handleSwift = (e) => {
    setCursorPostion(e);
    const value = e.target.value.trimStart().replace(/\s+/g, " ").toUpperCase();
    const regex = /^[A-Za-z0-9' -]+$/;
    if (regex.test(value) || value === "") {
      setSwift(value);
    }
    setSwiftError("");
  };

  // prettier-ignore
  const editHandler = (e) => {
    e.preventDefault();
    if (editDisable === true) {
      return;
    }
    setDisplayButton(true);
    setIsClicked(true);
    setEdit(true);
    editIconHandler(true);
    //set form fields disabled as false
    setEditSortCode(false);
    setEditAccountNumber(false);
    setEditAccountName(false);
    setEditBuildingSocietyCode(false);
    setEditSwift(false);

    setAccountNumberValue(
      bankAccounts && bankAccounts?.length > 0 && bankAccounts[0]?.accountNumber
        ? bankAccounts &&
            bankAccounts?.length > 0 &&
            bankAccounts[0]?.accountNumber
        : ""
    );
  };
  // prettier-ignore
  useEffect(() => {
    if (
      data?.updateJourneyInfo?.workItem ===
      WORK_ITEM_TYPE?.WORK_ITEM_RETIREMENT_BANK
    ) {
      const pendingFields = data?.updateJourneyInfo?.fields
        ? data?.updateJourneyInfo?.fields?.split(",")
        : [];
      //data?.updateJourneyInfo?.fields ? setStatus(true) : '';
      if (data?.updateJourneyInfo?.status === IDV_STATUS?.UPLOAD_DOCUMENT) {
        setShowUploadDocButton(true);
      }
      if (
        data?.updateJourneyInfo?.status === IDV_STATUS?.PENDING &&
        data?.updateJourneyInfo?.fields
      ) {
        setShowPendingStatus(true);
      }
      if (data?.updateJourneyInfo?.status === IDV_STATUS?.SUCCESS) {
        setSortCodePending(false);
        setAccountNumberPending(false);
        setAccountNamePending(false);
        setSocietyCodePending(false);
        setSwiftPending(false);

        setEdit(false);
      }
      if (data?.updateJourneyInfo?.status === IDV_STATUS?.UPLOAD_DOCUMENT ||
        data?.updateJourneyInfo?.status === IDV_STATUS?.PENDING) {
        pendingFields.includes("sortCode")
          ? setSortCodePending(true)
          : setSortCodePending(false);
        pendingFields.includes("accountNumber")
          ? setAccountNumberPending(true)
          : setAccountNumberPending(false);
        pendingFields.includes("accountName")
          ? setAccountNamePending(true)
          : setAccountNamePending(false);
        pendingFields.includes("societyCode")
          ? setSocietyCodePending(true)
          : setSocietyCodePending(false);
        pendingFields.includes("swift")
          ? setSwiftPending(true)
          : setSwiftPending(false);
      }
      if (data?.updateJourneyInfo?.status === IDV_STATUS?.FAILED) {
        setSortCodePending(false);
        setAccountNumberPending(false);
        setAccountNamePending(false);
        setSocietyCodePending(false);
        setSwiftPending(false);
        setSortCodeValue(
          bankAccounts && bankAccounts?.length > 0 && bankAccounts[0]?.sortCode
            ? bankAccounts &&
                bankAccounts?.length > 0 &&
                bankAccounts[0]?.sortCode
                  .match(new RegExp(".{1,2}", "g"))
                  .join("-")
            : ""
        );
        setAccountNumberValue(
          bankAccounts[0]?.accountNumber

        );
        setAccountName(
          bankAccounts && bankAccounts?.length > 0
            ? bankAccounts[0]?.accountName
            : ""
        );
        setsocietyCode(
          bankAccounts && bankAccounts?.length > 0
            ? bankAccounts[0]?.buildingSocietyCode
            : ""
        );
        setSwift(
          bankAccounts && bankAccounts?.length > 0
            ? bankAccounts[0]?.swift
            : ""
        );

        setEdit(false);
      }
    }
  }, [data]);
  // prettier-ignore
  const confirmHandler = () => {
    setIsClicked(true);
    let
      sortCodeErrorMessage,
      accountNumberMessage,
      accountNameErrorMessage,
      societyCodeErrorMessage,
      swiftCodeErrorMessage;
  props.setGetBankDetails(false);
  if (props.isBankAccount) {
    sortCodeErrorMessage =
      !sortCodeValue && formFieldAccess.includes("sortCode")
        ? "Required"
        : sortCodeValue.length < 8
          ? "less than 8"
          : "";
  } else {
    swiftCodeErrorMessage =
      !swift && formFieldAccess.includes("swift")
        ? "Required"
        : swift.length !== 8 && swift.length !== 11
          ? "Must be 8 or 11 characters"
          : !/^[A-Z0-9]+$/i.test(swift)
            ? "Must be alphanumeric"
            : !/^[A-Z]{4}/.test(swift)
              ? "First 4 characters must be letters (bank code)"
              : !/^[A-Z]{4}[A-Z]{2}/.test(swift)
                ? "Characters 5-6 must be letters (country code)"
                : !/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}/.test(swift)
                  ? "Characters 7-8 must be alphanumeric (location code)"
                  : swift.length === 11 &&
                      !/^[A-Z]{4}[A-Z]{2}[A-Z0-9]{2}[0-9]{3}$/.test(swift)
                    ? "Last 3 characters must be alphanumeric (branch code)"
                    : "";
  }
    accountNumberMessage =
      !accountNumber && formFieldAccess.includes("accountNumber")
        ? "Required"
        : accountNumber.length < 8
          ? "less than 8"
          : "";
    accountNameErrorMessage =
      formFieldAccess.includes("accountName") && !accountName
        ? "Required"
        : accountName.length > 40
          ? "Max length is 40 characters"
          : "";
    //Set error
    setSortCodeError(sortCodeErrorMessage);
    setAccountNumberError(accountNumberMessage);
    setAccountNameError(accountNameErrorMessage);
    setSocietyCodeError(societyCodeErrorMessage);
    setSwiftError(swiftCodeErrorMessage);

    //Setting pending to false
    setSortCodePending(false);
    setAccountNumberPending(false);
    setAccountNamePending(false);
    setSocietyCodePending(false);
    setSwiftPending(false);

    if (
      sortCodeErrorMessage ||
      accountNumberMessage ||
      accountNameErrorMessage ||
      societyCodeErrorMessage ||
      swiftCodeErrorMessage
    ) {
      setIsError(true);
    } else {
      setIsError(false);
      const sortCodeVal = sortCodeValue.replace(/-/g, "");
      if (props.isBankAccount) {
        confirmAPIHandler({
          accountNumber,
          sortCodeVal,
          societyCode,
          accountName,
        });
      } else {
        confirmAPIHandler({ swift, accountName, accountNumber });
      }
      
    }
  };

  // prettier-ignore
  const cancelHandler = (event) => {
    event.preventDefault();
    //Set error as empty
    setIsError(false);
    setSortCodeError("");
    setAccountNumberError("");
    setAccountNameError("");
    setSocietyCodeError("");

    //Set form field disabled true
    setEditSortCode(true);
    setEditAccountNumber(true);
    setEditAccountName(true);
    setEditBuildingSocietyCode(true);
    setEditSwift(true);

    //Reverting Back to previous state on click of cancel button
    setSortCodeValue(
      bankAccounts && bankAccounts?.length > 0 && bankAccounts[0]?.sortCode
        ? bankAccounts &&
            bankAccounts?.length > 0 &&
            bankAccounts[0]?.sortCode.match(new RegExp(".{1,2}", "g")).join("-")
        : ""
    );
    setAccountNumberValue(
      bankAccounts?.length > 0
    );
    setAccountName(
      bankAccounts && bankAccounts?.length > 0
        ? bankAccounts[0]?.accountName
        : ""
    );
    setsocietyCode(
      bankAccounts && bankAccounts?.length > 0
        ? bankAccounts[0]?.buildingSocietyCode
        : ""
    );
    setSwift(
      bankAccounts && bankAccounts?.length > 0
        ? bankAccounts[0]?.swift
        : ""
    );

    //Disabled component on reverting back
    setDisplayButton(false);
    setIsClicked(false);
    setEdit(false);
    editIconHandler(false);
  };
  return (
    <div className="personal-bank-section">
      <Cards
        title=""
        status={showPendingStatus}
        displayButton={displayButton}
        edit={edit}
        editHandler={editHandler}
        confirmHandler={confirmHandler}
        cancelHandler={cancelHandler}
        editDisable={editDisable}
        uploadButton={showUploadDocButton}
        uploadClick={props?.uploadClick}
      >
        {props.isBankAccount ? (
          <Card.Body style={{ padding: "0px" }}>
            <Row className="mb-4">
              <Col xs={12} sm={12} lg={12} md={12}>
                <div className="position-relative">
                  <FormFields
                    type="text"
                    variant={
                      checkFieldEnabled(
                        "sortCode",
                        editSortCode,
                        formFieldAccess
                      )
                        ? ""
                        : sortCodeError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={
                      <span>
                        <span>*</span>Sort code
                      </span>
                    }
                    value={sortCodeValue}
                    changeHandler={handleSortCode}
                    placeholder=""
                    maxLength={8}
                    minLength={8}
                    defaultValue={sortCode}
                  />
                  {sortCodeError ? (
                    <span className="position-absolute end-0 top-50 translate-middle-y sort-code-pending">
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : sortCodePending ? (
                    <span className="position-absolute end-0 top-50 translate-middle-y sort-code-pending">
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col xs={12} sm={12} lg={12} md={12}>
                <div className="position-relative">
                  <FormFields
                    type="text"
                    placeholder="House"
                    variant={
                      checkFieldEnabled(
                        "accountNumber",
                        editAccountNumber,
                        formFieldAccess
                      )
                        ? ""
                        : accountNumberError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={
                      <span>
                        <span>*</span>Account number
                      </span>
                    }
                    value={accountNumber}
                    maxLength={8}
                    minLength={8}
                    changeHandler={handleAccountNumber}
                  />
                  {accountNumberError ? (
                    <span className="position-absolute end-0 top-50 translate-middle-y account-number-pending">
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : accountNumberPending ? (
                    <span className="position-absolute end-0 top-50 translate-middle-y account-number-pending">
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col lg={12} xs={12}>
                <div className="position-relative">
                  <FormFields
                    type="text"
                    placeholder=""
                    variant={
                      checkFieldEnabled(
                        "accountName",
                        editAccountName,
                        formFieldAccess
                      )
                        ? ""
                        : accountNameError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={
                      <span>
                        <span>*</span>Account Holder&apos;s name
                      </span>
                    }
                    value={accountName}
                    changeHandler={handleAccountName}
                    maxLength={40}
                  />
                  {accountNameError ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : accountNamePending ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>

            <Row className="mb-4">
              <Col lg={12} xs={12}>
                <div className="position-relative">
                  <FormFields
                    type="text"
                    placeholder=""
                    variant={
                      checkFieldEnabled(
                        "societyCode",
                        editBuildingSocietyCode,
                        formFieldAccess
                      )
                        ? ""
                        : societyCodeError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={"Building society code"}
                    value={societyCode}
                    maxLength={20}
                    changeHandler={handleSocietyCode}
                  />
                  {societyCodeError ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : societyCodePending ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mandatory-text">
              <span className="manadetory-text">
                <span>*</span>mandatory information
              </span>
            </Row>
            {isError ? (
              <ErrorMessages
                text="Something's not quite right here. Please try again."
                className="account-alert-message"
              />
            ) : isClicked ? (
              status &&
              (data?.updateJourneyInfo?.status === "SUCCESS" ||
                props?.id3Status === true) ? (
                <ErrorMessages
                  text="Changes have been made to your account."
                  className="success-message"
                />
              ) : (
                ""
              )
            ) : (
              ""
            )}
            {props?.showLoader && <div className="bank-loader"></div>}
          </Card.Body>
        ) : (
          <Card.Body
            style={{ padding: "0px" }}
            className={isError ? "" : "swift-payment"}
          >
            <Row className="mb-4">
              <Col lg={12} xs={12}>
                <div className="position-relative">
                  <FormFields
                    variant={
                      checkFieldEnabled("swift", editSwift, formFieldAccess)
                        ? ""
                        : swiftError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={
                      <span>
                        <span>*</span>SWIFT (BIC)
                      </span>
                    }
                    value={swift}
                    changeHandler={handleSwift}
                    placeholder=""
                    maxLength={11}
                    minLength={8}
                  />
                  {swiftError ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : swiftPending ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col lg={12} xs={12}>
                <div className="position-relative">
                  <FormFields
                    type="text"
                    placeholder=""
                    variant={
                      checkFieldEnabled(
                        "accountName",
                        editAccountName,
                        formFieldAccess
                      )
                        ? ""
                        : accountNameError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={
                      <span>
                        <span>*</span>Account Holder&apos;s name
                      </span>
                    }
                    value={accountName}
                    changeHandler={handleAccountName}
                    maxLength={40}
                  />
                  {accountNameError ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : accountNamePending ? (
                    <span
                      className="position-absolute end-0 top-50 translate-middle-y list-icon red"
                      style={{ marginRight: "8px" }}
                    >
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col xs={12} sm={12} lg={12} md={12}>
                <div className="position-relative">
                  <FormFields
                    type="text"
                    placeholder="House"
                    variant={
                      checkFieldEnabled(
                        "accountNumber",
                        editAccountNumber,
                        formFieldAccess
                      )
                        ? ""
                        : accountNumberError
                          ? "form-field-error"
                          : "form-field-default"
                    }
                    Label={
                      <span>
                        <span>*</span>Account number
                      </span>
                    }
                    value={accountNumber}
                    maxLength={8}
                    minLength={8}
                    changeHandler={handleAccountNumber}
                  />
                  {accountNumberError ? (
                    <span className="position-absolute end-0 top-50 translate-middle-y account-number-pending">
                      <Icons
                        iconname="form-fields-exclamation-mark"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : accountNumberPending ? (
                    <span className="position-absolute end-0 top-50 translate-middle-y account-number-pending">
                      <Icons
                        iconname="form-fields-pending-non-editing"
                        variant="icon-sixteen-px"
                      />
                    </span>
                  ) : (
                    ""
                  )}
                </div>
              </Col>
            </Row>
            <Row className="mb-4">
              <Col md={12} className="bg-text">
                <div
                  className={
                    isError ? "check-box-bank-margin" : "check-box-bank"
                  }
                >
                  <CustomCheckbox
                    name="accept"
                    type="checkbox"
                    checked={props.checked}
                    onChange={props.onCheckboxChange}
                    label="I accept that SWIFT payments may incur a bank charge and will be converted at the bank’s exchange rate at the time of payment. Any incorrect or missing information will incur delays and may result in additional costs."
                    variantName="custom-checkbox "
                  />
                </div>
              </Col>
            </Row>
            {isError ? (
              <ErrorMessages
                text="Something's not quite right here. Please try again."
                className="account-alert-message"
              />
            ) : isClicked ? (
              status &&
              (data?.updateJourneyInfo?.status === "SUCCESS" ||
                props?.id3Status === true) ? (
                <ErrorMessages
                  text="Changes have been made to your account."
                  className="success-message"
                />
              ) : (
                ""
              )
            ) : (
              ""
            )}
            {props?.showLoader && <div className="bank-loader"></div>}
            <Row className="mandatory-text">
              <span className="manadetory-text">
                <span>*</span>mandatory information
              </span>
            </Row>
          </Card.Body>
        )}
      </Cards>
    </div>
  );
};

export default BankMandateForm;
